import React from 'react'
import RevenuMethodAdd from './RevenuMethodAdd'

const RevenueShareMethod = () => {
    return (
        <RevenuMethodAdd />
    )
}

export default RevenueShareMethod